import PropTypes from 'prop-types';
import { useNodes } from '@/stores/analysisStore';
import { getNodeOptions } from '@/utils/pathwayUtils';
import FormRow from './FormRow';
import Select from './Select';
export const ModuleSelect = ({ className = 'col-span-1' }) => {
  const nodes = useNodes();
  const nodeOptions = getNodeOptions(nodes);

  return (
    <FormRow label="Module" name="nodeId" className={className}>
      <Select name="nodeId" className="w-full truncate" options={nodeOptions} />
    </FormRow>
  );
};

ModuleSelect.propTypes = {
  className: PropTypes.string,
};
